export type SIndexTableSelectedItems = string[] | 'All';

export const S_INDEX_TABLE_SELECT_ALL_ITEMS = 'All';

export enum SIndexTableSelectionType {
    All = 'all',
    Page = 'page',
    Multi = 'multi',
    Single = 'single',
    Range = 'range',
}

export type SIndexTableRange = [number, number];

export type SIndexTableResourceName = {
    singular: string;
    plural: string;
};

export interface SIndexTableProviderProps {
    children?: React.ReactNode;
    selectable?: boolean;
    disableSelection?: boolean;
    itemCount: number;
    selectedItemsCount?: typeof S_INDEX_TABLE_SELECT_ALL_ITEMS | number;
    resourceName?: SIndexTableResourceName;
    loading?: boolean;
    hasMoreItems?: boolean;
    condensed?: boolean;
    onSelectionChange?(
        selectionType: SIndexTableSelectionType,
        toggleType: boolean,
        selection?: string | SIndexTableRange,
        position?: number
    ): void;
    paginatedSelectAllText?: string;
}

export type SIndexTableHandleSelectionChange = (
    selectionType: SIndexTableSelectionType,
    toggleType: boolean,
    selection?: string | SIndexTableRange,
    sortOrder?: number
) => void;

export interface SIndexTableBulkSelectionDataOptions {
    selectedItemsCount: number | typeof S_INDEX_TABLE_SELECT_ALL_ITEMS;
    itemCount: number;
    hasMoreItems?: boolean;
    resourceName?: {
        singular: string;
        plural: string;
    };
    defaultPaginatedSelectAllText?: string;
}

export interface SIndexTableHandleBulkSelectionOptions {
    onSelectionChange?(
        selectionType: SIndexTableSelectionType,
        toggleType: boolean,
        selection?: string | SIndexTableRange
    ): void;
}
